/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { Container, ServiceHeader } from "./styles";
import { InactiveActivity } from "views/components/Schedules/styles";
//#endregion
//#region Components
import Schedules from "views/components/Schedules/Schedules";
import CustomButton from "components/CustomButton/CustomButton";
import SchedulesSkelletonContent from "views/components/Schedules/components/SchedulesSkelletonContent/SchedulesSkelletonContent";
import ScheduleActivity from "./ScheduleActivity/ScheduleActivity";
import ScheduleFreeActivity from "./ScheduleFreeActivity";
//#endregion
//#region Icons
import EditIcon from "icons/EditIcon";
//#endregion
//#region Utils
import { RESOURCE_TEXT_LIST } from "views/Recursos/ResourcesLibrary/utils/constants";
import { QUANTITY_PER_PAGE } from "views/components/Schedules/utils/constants";
import { isPastSchedule } from "utils/date";
//#endregion

// Template
// const data = {
//     headers: [
//         {
//             render: (
// <ServiceHeader className="main-content">
//     <span>Tablet 01</span>
// </ServiceHeader>
//             )
//         }
//     ],
//     body: []
// };

const SchedulesWrapper = ({
    openShowDialogResourceForm,
    serviceList,
    isLoading,
    searchedFilters,
    data: {
        resourceTypes,
        electronicBrands,
        screenList,
        campusList,
        libraryList,
        reasonsForPenalize,
        penalties,
        blockList
    }
}) => {
    //#region States
    const [data, setData] = useState({
        headers: [],
        body: [],
        cellsManyHours: []
    });
    const [reasonsForPenalizeByResourceType, setReasonsForPenalizeByResourceType] = useState([]);
    const [hoursToIgnored, setHoursToIgnored] = useState(Array(7).fill([]));
    //#endregion
    //#region Effects
    useEffect(() => {
        setReasonsForPenalizeByResourceType(reasonsForPenalize.filter(({ resourceTypeId }) => resourceTypeId === searchedFilters.resourceTypeId));
    }, [searchedFilters.resourceTypeId]);
    useEffect(() => {
        fillData();
    }, [serviceList.value]);
    //#endregion
    //#region Functions
    const fillData = () => {
        if (!serviceList.value) return;
        const offsetColumns = Array(QUANTITY_PER_PAGE - serviceList.value.length).fill(null);
        const serviceListWithOffsetColumns = serviceList.value.concat(offsetColumns);
        setData({
            ...data,
            headers: serviceListWithOffsetColumns.map(getHeaderData),
            body: serviceListWithOffsetColumns.map(getBodyData),
        });
        fillHoursToIgnored();
    }
    const fillHoursToIgnored = () => {
        const newHoursToIgnored = serviceList.value.flatMap(({ resource, reservations, adminReservations }) => {
            return {
                resourceId: resource.id,
                // Se ordena para facilitar la búsqueda de reservas cercanas en función de las horas
                hours: [
                    ...reservations.map(({ schedule: { timeStart, timeEnd } }) => ({
                        start: timeStart,
                        end: timeEnd
                    })),
                    ...adminReservations.map(({ schedule: { timeStart, timeEnd } }) => ({
                        start: timeStart,
                        end: timeEnd
                    }))
                    // Ordenando las horas del más antiguo al más reciente
                ].sort((a, b) => a.start - b.start)
            };
        });
        setHoursToIgnored(newHoursToIgnored);
    }
    const getContentHeaderData = item => {
        if (!item)
            return <span></span>;
        const { name } = item;
        return (
            <>
                <span title={name}>{name}</span>
                <CustomButton
                    icon={<EditIcon />}
                    variant="terciary"
                    width="30px"
                    height="32px"
                    onClick={() => {
                        openShowDialogResourceForm({
                            resourceTypeId: null,
                            resource: item
                        });
                    }} />
            </>
        );
    }
    const getHeaderData = item => {
        const classList = ["main-content"];
        const resource = item?.resource;
        if (resource && !resource.active)
            classList.push("inactive");
        return {
            render: (
                <ServiceHeader className={classList.join(" ")}>
                    {getContentHeaderData(resource)}
                </ServiceHeader>
            )
        };
    }
    const getElectronicFieldsIfExist = electronic => {
        if (!electronic) return {};
        const { brandId, ...restElectronic } = electronic;
        return {
            ...restElectronic,
            brand: electronicBrands.find(({ id }) => id === brandId).name,
        };
    }
    const getGroupRoomFieldsIfExist = groupRoom => {
        if (!groupRoom) return {};
        const { screenId, ...restGroupRoom } = groupRoom;
        return {
            ...restGroupRoom,
            screen: screenList.find(({ id }) => id === screenId).name
        };
    }
    const getBodyData = resourceInfo => {
        if (!resourceInfo) return null;
        const { resource, reservations, adminReservations } = resourceInfo;
        const location = {
            campus: campusList.find(({ id }) => id === resource.campusId).name,
            library: libraryList.find(({ id }) => id === resource.libraryId).name
        };
        let resourceSimplifyInfo = {
            id: resource.id,
            name: resource.name,
            type: {
                id: resource.resourceTypeId,
                name: RESOURCE_TEXT_LIST[resource.resourceTypeId].capital.singular
            },
            ...getElectronicFieldsIfExist(resource.electronic),
            ...getGroupRoomFieldsIfExist(resource.groupRoom)
        };
        return {
            resource,
            reservations: reservations.map(reservation => {
                return {
                    ...reservation,
                    location,
                    resource: resourceSimplifyInfo
                };
            }),
            adminReservations: adminReservations.map(manualReservation => {
                return {
                    ...manualReservation,
                    location,
                    resource: resourceSimplifyInfo
                };
            })
        };
    }
    const isPartOfReservationOfManyHours = (resource, time) => {
        const foundHourIgnored = hoursToIgnored.find(({ resourceId }) => resourceId === resource.id);
        return foundHourIgnored?.hours.some(hourItem => time.totalMinutes > hourItem.start && time.totalMinutes < hourItem.end) || false;
    }
    const getQuantityCellsOfEmptyScheduleActivity = ({
        resource, time,
        isHourOclock
    }) => {
        const hoursToIgnoredOfResource = hoursToIgnored
            .find(({ resourceId }) => resourceId === resource.id)
            .hours;
        const prevHourReservation = hoursToIgnoredOfResource
            .find(hourItem => time.totalMinutes === hourItem.start - (hourItem.start % 60));
        const postHourReservation = hoursToIgnoredOfResource
            .find(hourItem => time.totalMinutes === hourItem.end);
        // Verificando hora anterior de la ocupada para rellenar el espacio
        if (prevHourReservation) {
            // Obteniendo la cantidad de celdas que posiblemente se tomarán a partir del horario de reserva previo al tiempo actual
            const posibleQuantityCells = (prevHourReservation.start - time.totalMinutes) / 15;
            // Obtiendo tiempo que debe ser ignorado si es que su hora de finalización es la hora de inicio del horario de reserva previo al tiempo actual
            const foundHourToIgnoredOfResource = hoursToIgnoredOfResource.find(({ end }) => prevHourReservation.start === end);
            if (foundHourToIgnoredOfResource) {
                // Se obtiene el tiempo que abarca este horario 
                const diff = foundHourToIgnoredOfResource.end - foundHourToIgnoredOfResource.start;
                // Si la diferencia es menor o igual a 30, entonces se decide retornar la posibl cantidad de celdas menos el tiempo que abarca el horario obtenido dividido entre 15, valor equivalente a 1 celda en la grilla de horarios
                if (diff <= 30)
                    return posibleQuantityCells - (diff / 15)
            }
            // Obteniendo ahora el horario posterior al previo para corroborar si es solo de 15 minutos
            const postClosestHourToIgnore = hoursToIgnoredOfResource.find(({ start }) => prevHourReservation.start > start);
            if (postClosestHourToIgnore && prevHourReservation.start - postClosestHourToIgnore.end === 15)
                return posibleQuantityCells - 2;
            // Devolviendo la cantidad de celdas posibles si ninguna condición fue verificada
            return posibleQuantityCells;
        }
        // Verificando hora posterior de la ocupada para rellenar el espacio
        if (postHourReservation) {
            let rows = 4 - (postHourReservation.end % 60) / 15;
            // Ajustando filas tomadas por si existe una intervalos ocupados posterior a la hora posterior
            const totalMinutesToOccupied = postHourReservation.end + 15 * rows;
            const reservationCross = hoursToIgnoredOfResource.find(hourItem => hourItem.start >= postHourReservation.end && hourItem.start <= totalMinutesToOccupied);
            if (reservationCross) {
                const offset = (totalMinutesToOccupied - reservationCross.start) / 15;
                rows -= offset;
            }
            return rows;
        }
        // Verificando si no es una hora en punto
        if (!isHourOclock)
            return null;
        // Por defecto retornando el tamaño de hora
        return 4;
    }
    const renderInactivityActivity = (idx, quantityCells = 4) => {
        return (
            <td key={idx} rowSpan={quantityCells}>
                <InactiveActivity heightRatio={quantityCells} />
            </td>
        );
    }
    function resourceIsInactiveAndHasNotReservations({ resource, reservations, adminReservations }) {
        return !resource.active && reservations.length === 0 && adminReservations.length === 0;
    }
    const renderActivity = ({
        cell: {
            time, item, idx
        },
        helpers: {
            renderEmptyActivity
        }
    }) => {
        const emptyActivityColor = idx % 2 === 0 ? "light" : "gray";
        const isHourOclock = time.minutes === 0;
        if (!item)
            return isHourOclock && renderEmptyActivity(idx, emptyActivityColor);
        const {
            resource, reservations, adminReservations 
        } = item;
        const isPast = isPastSchedule({
            date: searchedFilters.date,
            minutes: time.totalMinutes
        });
        if (!isPast && resourceIsInactiveAndHasNotReservations(item) && isHourOclock)
            return renderInactivityActivity(idx);
        const currentMinutes = time.totalMinutes;
        // Buscando reservas regulares
        const reservationFound = reservations.find(({ schedule }) => schedule.timeStart === currentMinutes);
        if (reservationFound) {
            const { student, schedule } = reservationFound;
            const quantityCells = (schedule.timeEnd - schedule.timeStart) / 15;
            return (
                <ScheduleActivity
                    key={idx}
                    classList={["presential"]}
                    header={{
                        title: student.responsable.name,
                        subtitle: student.responsable.id
                    }}
                    quantityCells={quantityCells}
                    reservation={{
                        ...reservationFound,
                        title: `${student.responsable.name} (${student.responsable.id})`,
                        penalizeData: {
                            reasonsForPenalize: reasonsForPenalizeByResourceType,
                            penalties,
                            blockList
                        }
                    }}
                    reloadData={serviceList.fill} />
            );
        }
        // Buscando reservas manuales
        const manualReservationFound = adminReservations.find(({ schedule }) => schedule.timeStart === currentMinutes);
        if (manualReservationFound) {
            const {
                name, details, schedule 
            } = manualReservationFound;
            const quantityCells = (schedule.timeEnd - schedule.timeStart) / 15;
            const classList = ["manual"];
            if (quantityCells < 4)
                classList.push("less-than-one-hour");
            return (
                <ScheduleActivity
                    key={idx}
                    header={{
                        title: name,
                        subtitle: details
                    }}
                    classList={classList}
                    quantityCells={quantityCells}
                    reservation={{
                        ...manualReservationFound,
                        title: name
                    }}
                    reloadData={serviceList.fill} />
            );
        }
        if (isPartOfReservationOfManyHours(resource, time))
            return null;
        const quantityCells = getQuantityCellsOfEmptyScheduleActivity({
            time,
            resource,
            isHourOclock
        });
        if (!quantityCells)
            return null;
        if (!resource.active) 
            return renderInactivityActivity(idx, quantityCells);
        if (isPast) 
            return renderEmptyActivity(idx, emptyActivityColor, quantityCells);
        return (
            <ScheduleFreeActivity
                key={idx}
                data={{
                    resourceType: {
                        types: resourceTypes,
                        value: resource.resourceTypeId
                    },
                    resourceId: resource.id,
                    date: searchedFilters.date
                }}
                quantityCells={quantityCells}
                reloadData={serviceList.fill}
                activityColor={emptyActivityColor} />
        );
    }
    //#endregion
    return (
        <Container>
            {isLoading
                ? <SchedulesSkelletonContent />
                : <Schedules
                    data={data}
                    filterDate={searchedFilters.date}
                    renderActivity={renderActivity} />}
        </Container>
    );
}

export default SchedulesWrapper;